import { render, staticRenderFns } from "./business-form-rps.vue?vue&type=template&id=b008def0"
import script from "./business-form-rps.vue?vue&type=script&lang=js"
export * from "./business-form-rps.vue?vue&type=script&lang=js"
import style0 from "./business-form-rps.vue?vue&type=style&index=0&id=b008def0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports